var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"md-layout"},[_c('CSLoading',{attrs:{"is-loading":_vm.isLoading}}),_c('h2',{staticClass:"page-title"},[_vm._v("Redirecting...")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }